import React, { useEffect, useState, useContext, FC } from 'react';

import Paper from '@material-ui/core/Paper';
import RightIcon from '@material-ui/icons/ChevronRight';

import { GlobalContext } from '../../../../../store';
import { IPage } from '../../../../../store/pages/store';

import Button from '../../../../../components/Button';
import Tooltip from '../../../../../components/Tooltip';
import AddPageWidget from './AddPageWidget';
import PageContent from './PageContent';
import { EmptyPolicies } from './EmptyPolicies';

const emptyPage = (): Partial<IPage> => ({
  content: '',
  name: ''
});
interface IProps {
  clubId: number;
}

const PagesSection: FC<IProps> = props => {
  const { clubId } = props;

  const { actions, pages } = useContext(GlobalContext);

  const [pageId, setPageId] = useState(0);
  const clubPages = (pages[clubId] || []).sort((a, b) => (a.name < b.name ? 1 : -1));

  const onPageAdd = async (name: string) => {
    return actions.pages.create(clubId, {
      content: '',
      name
    });
  };

  const onPageEdit = async (page: Partial<IPage>) => {
    return actions.pages.edit(clubId, page);
  };

  const onPageDelete = async (id: number) => {
    await actions.pages.remove(clubId, id);
  };

  const onSelect = (id: number) => () => {
    setPageId(id);
  };

  // cache is required
  useEffect(() => {
    actions.pages.get(clubId, false, true);
  }, []);

  useEffect(() => {
    if (!pageId && clubPages.length) {
      setPageId(clubPages[0].id);
    }
    if (clubPages.length && !clubPages.some(p => p.id === pageId)) {
      setPageId(clubPages[0].id);
    }
  }, [clubPages]);

  const currentPage =
    clubPages.length && pageId ? clubPages.find(p => p.id === pageId) || emptyPage() : emptyPage();

  return (
    <div className="pages-section">
      <div className="pages-content">
        <Paper className="left">
          <div className="policies-title">
            <h3>POLICY SECTIONS</h3>

            <Tooltip classes={{ fab: 'tooltip-fab--shift-top-2' }} sectionKey="POLICIES.TITLE" />
          </div>

          <AddPageWidget onSave={onPageAdd} />

          <div className="page-list">
            {clubPages.map(page => (
              <Button
                className={`button page-link ${currentPage.id === page.id ? 'selected' : ''}`}
                color="primary"
                key={`page-link-${page.id}`}
                onClick={onSelect(page.id)}
                variant="outlined"
              >
                {page.name}

                <RightIcon className="arrow" />
              </Button>
            ))}
          </div>
        </Paper>

        <Paper className="right">
          {currentPage.id ? (
            <PageContent
              onSave={onPageEdit}
              onDelete={onPageDelete}
              id={currentPage.id}
              content={currentPage.content}
              name={currentPage.name}
            />
          ) : (
            <EmptyPolicies />
          )}
        </Paper>
      </div>
    </div>
  );
};

export default PagesSection;
